import { FormControlLabel, FormControlLabelProps, Radio, RadioGroup } from '@mui/material'
import InputLabel from '@mui/material/InputLabel'
import useStyles from 'src/components/shared/ui/form/fields/styles'
import { FormField } from 'src/enums/Form'

type Props = {
  id: string
  fieldName: FormField
  label?: string
  value: any
  getValue?: (data: any, field?: string) => void
  items: any
}

function RadioGroupField({ id, fieldName, label, value, getValue, items }: Props): JSX.Element {
  const classes = useStyles()
  const input = (event: React.ChangeEvent<{ value: unknown }>) => {
    if (getValue) {
      getValue(event.target.value, fieldName)
    }
  }

  return (
    <>
      <div className={classes.inputField}>
        {label && (
          <InputLabel id={`${id}-label`} key={`${id}-label`} className={classes.inputLabel}>
            {label}
          </InputLabel>
        )}
        <RadioGroup
          row
          aria-label="position"
          name="position"
          value={value}
          onChange={input}
          key={`${id}-radio-group`}
        >
          {items.map((item: FormControlLabelProps) => (
            <FormControlLabel
              key={`${item.label}-control-label`}
              value={item.value}
              control={<Radio key={`${item.label}-radio`} color="primary" />}
              label={item.label}
              labelPlacement={item.labelPlacement ? item.labelPlacement : 'end'}
              style={{ color: '#262626' }}
            />
          ))}
        </RadioGroup>
      </div>
    </>
  )
}

export default RadioGroupField
